import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { loadModelViewer } from "../utils/loadModelViewer";
import SeoHelmet from "../components/SeoHelmet";
import { FaSun, FaMoon } from "react-icons/fa";
import { useTheme } from "../context/ThemeContext";

import HeroStatementSection from "../components/HeroStatementSection";
import ServiceHero from "../components/ServiceHero";
import TechStackHero from "../components/TechStackHero";

import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";


function Hero({
  serviceIsOpen,
  onServiceToggle,
  techIsOpen,
  onTechToggle,
  serviceHeaderRef,
  techHeaderRef,
  className = "",
}) {
  const navigate = useNavigate();
  const { isDark, setIsDark } = useTheme();

  useEffect(() => {
    loadModelViewer();
  }, []);


  return (
    <>
      {/* 🦇 Theme-Toggle — Portal direkt in body, außerhalb jeder Transform */}
      {createPortal(
        <div style={{ position: "fixed", top: "var(--navbar-height, 56px)", right: "26px", zIndex: 9999 }}>
          <button
            onClick={() => setIsDark(!isDark)}
            title={isDark ? "Paper-Modus" : "Dark-Modus"}
            style={{
              background: "#1a1a1a",
              border: "1px solid #2a2a2a",
              borderTop: "none",
              color: "#AC8E66",
              width: "36px",
              height: "32px",
              borderRadius: "0 0 10px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
            }}
          >
            {isDark ? <FaSun size={11} /> : <FaMoon size={11} />}
          </button>
        </div>,
        document.body
      )}

      <SeoHelmet
        title="Denis Bitter — Fullstack Entwickler & Software Architekt"
        description="Ich entwickle Web-Apps, die funktionieren und bleiben. React, Angular, Flutter — für Startups und Unternehmen die verlässliche Software brauchen. Remote oder vor Ort."
        url="https://www.denisbitter.de/"
        image="https://www.denisbitter.de/images/hero-og.png"
      />

      {/* ========== AKT 1: MEIN WARUM ========== */}
  <HeroStatementSection className={className} isDark={isDark} />

      {/* ========== 2. SOFTWARE DIE FUNKTIONIERT ========== */}
      <ServiceHero isOpen={serviceIsOpen} onToggle={onServiceToggle} headerRef={serviceHeaderRef} isDark={isDark} />

      {/* ========== 3. TECH STACK + VERTRAUEN ========== */}
      <TechStackHero
        isOpen={techIsOpen}
        onToggle={onTechToggle}
        headerRef={techHeaderRef}
        isDark={isDark}
        onCompanyClick={() => {
          navigate("/about#referenzen");
          setTimeout(() => window.scrollTo({ top: 0, behavior: "instant" }), 0);
        }}
      />

   
    </>
  );

}

export default Hero;
